/* global Cookiebot */

export default async function init() {
  // Check if Cookiebot is available
  if (typeof Cookiebot === 'undefined') {
    console.warn('Cookiebot is not loaded');
    return;
  }

  // Initial check
  handleConsent();

  // Listen for consent changes
  window.addEventListener('CookiebotOnAccept', () => handleConsent());
  window.addEventListener('CookiebotOnDecline', () => handleConsent());
}

const handleConsent = () => {
  const containers = document.querySelectorAll('.c-video__container');

  containers.forEach((container) => {
    const iframe = container.querySelector('.c-video__iframe');
    const consentMessage = container.querySelector('.c-video__blocked');

    if (!iframe || !consentMessage) return;

    // Check if marketing cookies are accepted
    if (Cookiebot.consent.marketing) {
      // Load the iframe
      const { src: dataSrc } = iframe.dataset;
      if (dataSrc) {
        // Set the src attribute
        iframe.src = dataSrc;
        iframe.removeAttribute('data-src');
      }
      consentMessage.style.display = 'none';
    } else {
      // Hide the iframe and show consent message
      iframe.src = '';
      if (iframe.dataset.src) {
        iframe.setAttribute('data-src', iframe.dataset.src);
      }
      consentMessage.style.display = 'block';
    }
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  init();
});
